import { useNavigate } from 'react-router-dom';
import { useAuth } from './useAuth';

/**
 * Hook for handling user logout
 * Clears authentication and redirects to home
 */
export const useLogout = () => {
  const navigate = useNavigate();
  const { clearAuth } = useAuth();

  const logout = () => {
    clearAuth();
    navigate('/');
  };

  return { logout };
};
